import Vue from 'vue'
import Router from 'vue-router'
import jwt_decode from "jwt-decode";
import store from './store'
import frame from "./App.vue";

Vue.use(Router)

export default new Router({
    // base: process.env.BASE_URL,
    routes: [

        {
            path: '/user',
            name: 'user',
            component: () => import('./tables/adminTables/UserTable.vue'),
        },
        {
            path: '/grade',
            name: 'grade',
            component: () => import('./tables/adminTables/settingsTables/GradeTable.vue'),
        },
        {
            path: '/presence',
            name: 'presence',

            component: () => import('./views/Presence/Presence.vue'),
            children: [
                {
                    path: '',
                    component: () => import('./views/Presence/PresenceTable/PresenceTable.vue'),
                },
                {
                    path: '/presence/constant',
                    component: () => import('./views/Presence/PresenceConstant/PresenceConstant.vue'),
                },
            ]
        },
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
        },
        {
            path: '/study',
            name: 'study',
            component: () => import('./tables/mainTables/StudyTable.vue'),
        },
        {
            path: '/pupil-dashboard',
            name: 'pupil-dashboard',
            component: () => import('./views/pupilDashboard/PupilDashboard.vue'),
        },
        // {
        //     path: '/class-dashboard',
        //     name: 'class-dashboard',
        //     component: () => import('./views/tests/GradeRouter.vue'),
        //
        // },

        // {
        //     path: '/test',
        //     name: 'test',
        //     component: () => import('./views/tests/TestRouter.vue'),
        //
        // },
        {
            path: '/tracing',
            name: 'tracing',
            component: () => import('./tables/mainTables/TracingTable.vue'),
        },
        {
            path: '/lessonTime',
            name: 'lessonTime',
            component: () => import('./tables/adminTables/settingsTables/LessonTimeTable.vue'),
        },
        {
            path: '/presenceStatus',
            name: 'presenceStatus',
            component: () => import('./tables/adminTables/settingsTables/PresenceStatusTable.vue'),
        },
        {
            path: '/presenceShow',
            name: 'presenceShow',
            component: () => import('./views/Home/PresenceShow.vue'),
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/report',
            name: 'Report',
            component: () => import('./views/report/Report.vue'),
            children: [
                {
                    path: '',
                    component: () => import('./views/report/gradeReport/GradeReport.vue')

                },
                {
                    path: '/report/pupil',
                    component: () => import('./views/report/pupilReport/PupilReport.vue')
                },
                {
                    path: '/report/menage',
                    component: () => import('./views/report/menageReport/MenageReport.vue')
                },
                {
                    path: '/report/admin',
                    component: () => import('./views/report/adminReport/AdminReport.vue')
                }, {
                    path: '/report/descriptions',
                    component: () => import('./views/report/descriptionReport/DescriptionsReport')
                },
            ]
        },
        // {
        //   path: '/report/grade',
        //   name: 'ReportGrade',
        //   component: () => import('./views/report/gradeReport/GradeReport.vue')
        // },
        // {
        //   path: '/report/pupil',
        //   name: 'ReportPupil',
        //   component: () => import('./views/report/pupilReport/PupilReport.vue')
        // },
        {
            path: '/pupil',
            name: 'pupil',
            component: () => import('./tables/adminTables/PupilTable.vue'),
            // beforeEnter: (to, from, next) => {
            //   if (store.state.user.role === "ADMIN") {
            //     next()
            //   } else {
            //     next('/')
            //   }
            // }
        }, {
            path: '/generalData',
            name: 'generalData',
            component: () => import('./views/GeneralData.vue'),
            // beforeEnter: (to, from, next) => {
            //   if (store.state.user.role === "ADMIN") {
            //     next()
            //   } else {
            //     next('/')
            //   }
            // }
        },
        {
            path: '/schedule',
            name: 'schedule',
            component: () => import('./views/Schedule/ScheduleRouter.vue'),
            children: [
                {
                    path: '',
                    component: () => import('./views/Schedule/ScheduleGrade/Schedule.vue'),

                },
                {
                    path: '/schedule/teacher',
                    component: () => import('./views/Schedule/ScheduleTeacher/Schedule.vue'),
                },
            ]
        },
        {
            path: '/test',
            name: 'test',
            component: () => import('./views/tests/TestRouter.vue'),
            children: [
                {
                    path: '',
                    component: () => import('./views/tests/scoreTest/ScoreTest.vue'),
                },
                {
                    path: '/test/names',
                    component: () => import('./views/tests/testsNames/TestNames.vue'),
                },
                {
                    name: 'testTable',

                    path: '/test/table',
                    component: () => import('./views/tests/testTable/TestTable.vue'),
                },
            ]
        },
        {
            path: '/subjectLesson',
            name: 'subjectLesson',
            component: () => import('./tables/adminTables/settingsTables/SubjectTable.vue'),
            // beforeEnter: (to, from, next) => {
            //   if (store.state.user.role === "ADMIN") {
            //     next()
            //   } else {
            //     next('/')
            //   }
            // }
        },
    ]
})
